import React, { Component, PropTypes } from 'react';

let $ = window.jQuery;

export default class BootstrapSelect extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        help: PropTypes.string.isRequired
    };

    state = {
        val : ''
    };

    componentDidMount() {
        this.setState({
            val: this.props.val
        });

        $('#'+this.props.id).selectpicker();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            val: nextProps.val
        }, () => {
            $('#'+this.props.id).selectpicker('refresh');
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    handleChange = (e) => {
        this.setState({
            val: e.target.val
        });

        this.props.onChange(e);
    };

    render() {
        return (
            <div className={"form-group form-md-line-input " + this.props.id}>
                <select data-live-search="true" data-size="3" id={this.props.id}
                        className="form-control" value={this.state.val}
                        onChange={this.handleChange}>

                    {this.props.options.map((item, i) => {
                        return (
                            <option value={item.value} key={i} disabled={item.disabled}>{item.label}</option>
                        )
                    })}
                </select>
                <label htmlFor={this.props.id}>{this.props.label}</label>
                <span className="help-block">{this.props.help}</span>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/BootstrapSelect.js
 **/